import React, { useMemo } from "react";

import Select from "antd/es/select";
import { useIntl } from "react-intl";

import TripType from "@mapmycustomers/shared/enum/mileageTracking/TripType";

import getTripTypeDisplayName from "@app/util/ui/getTripTypeDisplayName";

import styles from "./TripTypeField.module.scss";

interface Props {
  disabled?: boolean;
  onChange: (value: null | TripType) => void;
  value?: null | TripType;
}

const TripTypeField: React.FC<Props> = ({ disabled, onChange, value }) => {
  const intl = useIntl();

  const options = useMemo(() => {
    return [TripType.BUSINESS, TripType.PERSONAL, null].map((tripType) => ({
      label: getTripTypeDisplayName(intl, tripType),
      value: tripType,
    }));
  }, [intl]);

  return (
    <Select<null | TripType>
      className={styles.container}
      disabled={disabled}
      dropdownMatchSelectWidth={false}
      onChange={onChange}
      options={options}
      placeholder={intl.formatMessage({
        id: "view.selectBar.button.bulkEdit.panel.changeTripType.placeholder",
        defaultMessage: "Select classification",
        description: "Select trip type placeholder",
      })}
      size="large"
      value={value}
    />
  );
};

export default TripTypeField;
